import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reject-reason',
  templateUrl: './reject-reason.component.html',
  styleUrls: ['./reject-reason.component.css'],
})
export class RejectReasonComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  private saveApi = environment.url + environment.incubatorApprovalSave;
  /**
   * Constructor for RejectReasonComponent.
   *
   * @param data - The data injected into the dialog.
   * @param fb - FormBuilder for creating the form.
   * @param makeapi - ApiService for making API calls.
   * @param notify - NotifyService for displaying notifications.
   * @param dialogRef - Reference to the dialog opened.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<RejectReasonComponent>
  ) {
    /**
     * Initialize the form group with form controls.
     */
    this.reasonForm = this.fb.group({
      incubatorUserId: [''], // Incubator user ID
      status: [''], // Status of the rejection
      reason: ['', [Validators.required]], // Reason for rejection
    });

    /**
     * Store the injected data in a local variable.
     */
    this.datas = data;

    /**
     * Set the default values for the form controls.
     */
    let getform = this.reasonForm.value;
    getform.incubatorUserId = this.datas._id; // Assign incubator user ID from data
    getform.status = -1; // Set status to default -1
    this.reasonForm.patchValue(getform); // Update the form values
  }
  get add() {
    return this.reasonForm.controls;
  }
  ngOnInit(): void {}
  /**
   * Saves the rejection reason to the API.
   * Constructs the request payload and sends it using the API service.
   * Closes the dialog and notifies success upon completion.
   */
  saveReason() {
    let getform = this.reasonForm.value;
    // Check if the form is invalid
    if (this.reasonForm.invalid) {
      // Mark all the form fields as touched
      this.reasonForm.markAllAsTouched();
      // Notify the user about the error
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Send the request to the API
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Check if the response is successful
        if (data.responseStatus == 'Success') {
          // Notify the user about the success
          this.notify.notifysuccess(data.responseMessage);
          // Close the dialog
          this.cancelReason();
        } else {
          // Notify the user about the error
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  /**
   * Cancels the rejection reason dialog.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    // Reset the form fields
    this.reasonForm.reset();

    // Close the dialog
    this.dialogRef.close();
  }
}
